import { pipelineFetch, PIPELINE_URL } from './pipeline-auth';

export interface BriefRequest {
  id: string;
  brand_name: string;
  contact_name: string;
  contact_email: string;
  category: string;
  product_name: string;
  keyword_1: string;
  keyword_2?: string;
  competitor_1: string;
  competitor_2?: string;
  status: 'pending_data' | 'generating' | 'ready';
  created_at: string;
  updated_at?: string;
}

export async function createBriefRequest(data: object): Promise<BriefRequest> {
  const res = await pipelineFetch('/api/brief-request', {
    method: 'POST',
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`Brief request error: ${res.statusText}`);
  return res.json();
}

export async function generateBrief(requestId: string): Promise<{ success: boolean }> {
  const res = await pipelineFetch('/api/generate-brief', {
    method: 'POST',
    body: JSON.stringify({ request_id: requestId }),
  });
  if (!res.ok) throw new Error(`Generate brief error: ${res.statusText}`);
  return res.json();
}

export async function listBriefRequests(): Promise<BriefRequest[]> {
  const res = await pipelineFetch('/api/brief-requests');
  if (!res.ok) throw new Error(`List brief requests error: ${res.statusText}`);
  return res.json();
}

// Opened directly in a browser tab, so it carries no Authorization header.
// GET /api/brief/:id is intentionally unauthenticated on the server — the brief
// is the shareable deliverable sent to the brand. Treat the id as the only
// thing standing between a link-holder and the brief.
export function getBriefUrl(requestId: string): string {
  return `${PIPELINE_URL}/api/brief/${requestId}`;
}
